import { render, staticRenderFns } from "./CreateWorkflowProcess.vue?vue&type=template&id=963a6e24&scoped=true"
import script from "./CreateWorkflowProcess.vue?vue&type=script&lang=js"
export * from "./CreateWorkflowProcess.vue?vue&type=script&lang=js"
import style0 from "./CreateWorkflowProcess.vue?vue&type=style&index=0&id=963a6e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a6e24",
  null
  
)

export default component.exports